import { FunctionComponent, useState } from 'react';
import { Alert, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { WebEntity } from '../../entities/types';
import { GenericMultiInputForm } from './GenericMultiInputForm';
import GenericIcons from './GenericIcons';

const ModalButton: FunctionComponent<{ endpoint: string; toggle: () => void }> = ({
  endpoint,
  toggle
}) => (
  <button id={endpoint} color='green' onClick={toggle} className='btn-ingreso-manual'>
    <GenericIcons icon='add' imageStyle={{ margin: 0 }} />
    {`Ingreso Manual`}
  </button>
);

const renderModalButton = (
  alternativeButton: ((toggle: () => void) => JSX.Element) | undefined,
  toggle: () => void,
  endpoint: string
) =>
  alternativeButton ? (
    alternativeButton(toggle)
  ) : (
    <ModalButton toggle={toggle} endpoint={endpoint} />
  );

const voidFunction = () => {};

type GenericModalMultiInputFormProps<T> = {
  webEntity: WebEntity<T>;
  errorMsg: string;
  isAuthenticated: boolean;
  isAdmin: boolean;
  actionFn: (formFields: any) => any;
  alternativeButton?: (toggle: () => void) => JSX.Element;
  title?: string;
  centered?: boolean;
  closeOnClickOut?: boolean;
  actionName?: string;
};

const GenericModalMultiInputForm = <T,>({
  webEntity,
  errorMsg = '',
  isAuthenticated,
  isAdmin,
  actionFn,
  alternativeButton,
  title = '',
  centered = false,
  closeOnClickOut = false,
  actionName = ''
}: GenericModalMultiInputFormProps<T>) => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  const onSubmit = async (e: Event, formFields: T) => {
    e.preventDefault();

    // Add Entity
    const res = await actionFn(formFields);
    return res;
  };

  const { name, fields, endpoint } = webEntity;

  return (
    <>
      {isAuthenticated ? (
        renderModalButton(alternativeButton, toggleModal, endpoint)
      ) : (
        <h4 className='mb-3 ml4'>{`Identifícate para administrar ${name}`}</h4>
      )}
      <Modal
        {...{
          isOpen: modal,
          autoFocus: false,
          centered,
          toggle: closeOnClickOut ? toggleModal : voidFunction,
          size: 'xl',
          className: 'vdr-gen-modal'
        }}>
        <ModalHeader toggle={toggleModal}>{title || `Agregar ${name}`}</ModalHeader>
        <ModalBody>
          {errorMsg && <Alert color='danger'>{errorMsg}</Alert>}
          <GenericMultiInputForm
            {...{
              fields: fields,
              onSubmit,
              toggleModal,
              actionName,
              isAdmin,
              nameEndPoint: endpoint
            }}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default GenericModalMultiInputForm;
